import { ComponentRef, Injectable, TemplateRef, Type } from '@angular/core';
import { ContextMenuElement } from '@m4u-angular/base/classes/BaseClasses';
import { BaseDataSourceAbstract } from '@m4u-angular/base/datalayer/BaseDataSourceAbstract';
import { BottomSheetContextMenuComponent } from '@m4u-angular/ui/components/bottom-sheet-context-menu/bottom-sheet-context-menu.component';
import { BottomSheetListComponent } from '@m4u-angular/ui/components/bottom-sheet-list/bottom-sheet-list.component';
import { from, Observable } from 'rxjs';
import { BottomSheetComponent, BottomSheetProvider } from 'swipe-bottom-sheet/angular';
import { ScreenService } from './screen.service';

@Injectable()
export class BottomSheetService {
    constructor(private bottomSheet: BottomSheetProvider, private screenService: ScreenService) {}

    ShowComponent(componentType: Type<any>, title: string, optionalParams?: any, height?: string | number): Observable<any> {
        const componentRef = this.bottomSheet.create(componentType, {
            title: title,
            stops: [270],
            props: optionalParams || {},
            height: height
        });

        return this.ShowBottomSheet(componentRef);
    }

    ShowTemplate(template: TemplateRef<any>, title: string, height?: string | number, noNeedDestroy?: boolean): Observable<any> {
        const componentRef = this.bottomSheet.create(template, {
            title: title,
            stops: [270],
            height: height,
            props: {
                noNeedDestroy: noNeedDestroy
            }
        });
        return this.ShowBottomSheet(componentRef);
    }

    ShowList(title: string, dataSource: BaseDataSourceAbstract | any[], isMultiSelection: boolean = false, valueExpr: string = "EntryID", displayExpr: string = "Name", template: TemplateRef<any> = null): Observable<any> {
        const result = this.bottomSheet.show(BottomSheetListComponent, {
            title: title,
            stops: [270],
            props: {
                DataSource: dataSource,
                ValueExpr: valueExpr,
                DisplayExpr: displayExpr,
                IsMultiSelection: isMultiSelection,
                ListTemplate: template
            }
        });
        return from(result);
    }

    ShowContextMenu(title: string, contextMenuItems: ContextMenuElement[]) {
        const result = this.bottomSheet.show(BottomSheetContextMenuComponent, {
            title: title,
            stops: [270],
            props: {
                MenuItems: contextMenuItems,
            }
        });
        return from(result);
    }

    private ShowBottomSheet(componentRef: ComponentRef<BottomSheetComponent<unknown>>) {
        const componentRefProps = componentRef?.instance?.context?.props as any;
        componentRefProps && (componentRefProps.BottomSheetContext = componentRef.instance.context);

        const isRTL = this.screenService.IsRTL();

        return from(new Promise(function (resolve) {
            componentRef.instance.onInit = function () {
                const closeButton = document.createElement('div');
                closeButton.classList.add('bottom-sheet-close-button');
                
                const closeButtonIcon = document.createElement('i');
                closeButtonIcon.classList.add('mdi');
                closeButtonIcon.classList.add('mdi-close');

                closeButton.appendChild(closeButtonIcon);
                closeButton.onclick = (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    componentRef.instance.context.dismiss();
                }

                const bottomSheetLine = document.createElement('div');
                bottomSheetLine.classList.add('bottom-sheet-line');

                const sheetElement = componentRef.instance.sheet?.nativeElement;
                sheetElement?.classList.add(isRTL ? 'RTL' : 'LTR');

                const sheetTitle = sheetElement?.children[0];
                sheetTitle?.appendChild(bottomSheetLine);
                sheetTitle?.appendChild(closeButton);

                componentRef.instance.open();
            };
            componentRef.instance.onClose = function (value) {
                resolve(value);
                (!componentRefProps || !componentRefProps.noNeedDestroy) && componentRef.destroy();
            };
        }));
    }
}